import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import AuthShell from "@/pages/auth/AuthShell";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const { user, refreshUser } = useAuth();
  const [state, setState] = useState({ status: "loading", message: "" });
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const token = params.get("token");
    if (!token) return setState({ status: "error", message: "This verification link is incomplete." });
    api.post("/auth/verify-email", { token })
      .then(() => { setState({ status: "ok" }); refreshUser().catch(() => {}); })
      .catch((e) => setState({ status: "error", message: errMsg(e) }));
  }, [params, refreshUser]);

  const next = user ? "/dashboard" : "/login";
  return (
    <AuthShell title="Email verification">
      <div className="card-surface p-8 text-center" data-testid="verify-email-result">
        {state.status === "loading" && <Loader2 className="h-8 w-8 animate-spin mx-auto text-ds-plum" />}
        {state.status === "ok" && (
          <>
            <CheckCircle2 className="h-10 w-10 text-emerald-600 mx-auto" />
            <p className="mt-4 font-display text-xl font-bold" data-testid="verify-email-success">Your email is verified.</p>
            <p className="mt-1 text-sm text-ds-inksoft">Next, record parental consent for your child.</p>
          </>
        )}
        {state.status === "error" && (
          <>
            <XCircle className="h-10 w-10 text-rose-600 mx-auto" />
            <p className="mt-4 font-display text-xl font-bold" data-testid="verify-email-error">We could not verify this link</p>
            <p className="mt-1 text-sm text-ds-inksoft">{state.message} You can request a new link from your dashboard.</p>
          </>
        )}
        {state.status !== "loading" && (
          <Link to={next} className="btn-pill mt-6 inline-flex items-center bg-ds-plum text-white hover:bg-[#3d0232]" data-testid="verify-email-continue">
            {user ? "Go to dashboard" : "Sign in"}
          </Link>
        )}
      </div>
    </AuthShell>
  );
}
